let list = [];

let currentLng = 116.404, currentLat = 39.915;

for (let i = 0; i < 50; i++) {
    list.push({
        id: i + 1,
        type: ['red', 'green', 'black'][parseInt(Math.random() * 3)],
        position: { lng: currentLng, lat: currentLat }
    });

    currentLat += 50;
}

export default list;



// WEBPACK FOOTER //
// ./src/configure/http/mock/response/index/queryMapDeviceList.js